<template>
    <div>
        <template v-for="(item,index) in subItems">                                      
            <split-item :ref="'subitem_'+index" v-model="subItems[index]" :key="index" />          
        </template>
        <span class="subheading ml-3"> Sum: {{new Intl.NumberFormat('no-NO', { style: 'currency', currency: 'NOK' }).format(total) }}</span>
    </div>
</template>

<script>
    import SplitItem from './SplitItem.vue';
    import {apiPost} from '@/dal.js';
    export default {
        name: 'Splitter',
        props: ['value'],
        components: {SplitItem},
        data: function() {
            return	{
                subItems : [{'catErrorMsg':null,'catDescriptionMsg':null,'amountDescriptionMsg':null}],
            }
        },


        created(){
        },

        computed:{
            total(){
                let result = 0;
                for (let index = 0; index < this.subItems.length; index++) {                    
                    const element = this.subItems[index]; 
                    if(element.hasOwnProperty("TRA_AMOUNT")){
                        result = result-element.TRA_AMOUNT;
                    }                                                           
                }
                return result;
            }
        },

        watch:{
            subItems(){
                if(this.subItems[this.subItems.length-1].TRA_AMOUNT){
                    this.subItems.push({'catErrorMsg':null,'catDescriptionMsg':null,'amountDescriptionMsg':null});
                }
            }
        },

        methods:{
            makeNewTransaction(subItem){
                let result = {}
                
                result.TRA_ID = null;
                result.TRA_DATE = this.value.TRA_DATE;
                result.TRA_TYPE = 'SubItem';
                result.TRA_REF = this.value.TRA_ID;
                result.TRA_TEXT = subItem.TRA_TEXT;
                result.TRA_AMOUNT = subItem.TRA_AMOUNT*-1;
                result.TRA_CAT_ID = subItem.TRA_CAT_ID;
                result.TRA_ACCOUNT = this.value.TRA_ACCOUNT;

                return result;
            },

            subItemsAreValid(){                
                let result = true;
                for (let index = 0; index < this.subItems.length; index++) {                
                    let ref = this.$refs['subitem_'+index][0];
                    let itemValid = ref.validate();
                    result = result && itemValid;
                }                                                           
                return result;
            },

            save(){
                return new Promise((resolve,reject)=>{
                    if(this.subItemsAreValid()){
                        let promises = [];
                        this.subItems.map(item=>{
                            if(item.TRA_AMOUNT){
                               promises.push(apiPost('db/transaction',this.makeNewTransaction(item)));
                            }
                        });
                        Promise.all(promises).then(()=>{                            
                            resolve();
                        }).catch(error=>{
                            reject(error)
                        });                        
                    } else{
                        reject("Subitems are not valid");
                    }
                    
                });
            },
        },
    }
</script>

<style scoped>

</style>
